import { useIntl } from 'react-intl';

import { openModal } from 'utils/modal';

import BRPreviewImage from 'components/BRPreviewImage/BRPreviewImage';

import './DeliveryImages.less';

const DeliveryImages = ({ consigneeImages, starImages, hubImages }) => {
  const intl = useIntl();

  const renderImages = (images, isObject = true) =>
    images.map((img, index) => {
      const imageUrl = isObject ? img?.imageUrl : img;
      return (
        <img
          key={index}
          className="br-delivery-images__single-image"
          src={imageUrl}
          onClick={() =>
            openModal(BRPreviewImage, {
              previewImage: imageUrl
            })
          }
        />
      );
    });

  return (
    <div className="br-delivery-images__container">
      {!!consigneeImages?.length && (
        <div className="br-delivery-images__section-wrapper">
          <span className="br-delivery-images__section-header">
            {intl.formatMessage({
              id: 'deliveries.delivery_details.delivery_images.consignee_images_header'
            })}
          </span>
          <div className="br-delivery-images__images-wrapper">
            {renderImages(consigneeImages, true)}
          </div>
        </div>
      )}
      {!!starImages?.length && (
        <>
          <span className="br-delivery-images__section-header">
            {intl.formatMessage({
              id: 'deliveries.delivery_details.delivery_images.star_images_header'
            })}
          </span>
          <div className="br-delivery-images__images-wrapper">
            {renderImages(starImages, false)}
          </div>
        </>
      )}
      {!!hubImages?.length && (
        <>
          <span className="br-delivery-images__section-header">
            {intl.formatMessage({
              id: 'deliveries.delivery_details.delivery_images.hub_images_header'
            })}
          </span>
          <div className="br-delivery-images__images-wrapper">
            {renderImages(hubImages, false)}
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryImages;
